
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './main.css';
import 'vuetify/dist/vuetify.min.css'
// import 'firebase/auth'

// import firebase from 'firebase'

// const firebaseConfig = {
//   apiKey: "AIzaSyBBmgd5Y4H-uFpum29TrGGZLHtmzai0ZzA",
//   authDomain: "propertygroupapp.firebaseapp.com",
//   databaseURL: "https://propertygroupapp-default-rtdb.firebaseio.com",
//   projectId: "propertygroupapp",
//   storageBucket: "propertygroupapp.appspot.com",
//   messagingSenderId: "273183014902",
//   appId: "1:273183014902:web:477ab274c64b0ea4e2d1d7"
// };

// firebase.initializeApp(
//   firebaseConfig
// );

// const auth = firebase.auth();

import GmapVue from 'gmap-vue'

Vue.use(GmapVue, {
  load: {
    // [REQUIRED] This is the unique required value by Google Maps API
    key: 'AIzaSyAhxCYsXLgXy7QXKdoY2ZNSmZtu-VvjIxM',
    // [OPTIONAL] This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    libraries: 'places',

    // [OPTIONAL] If you want to set the version, you can do so:
    v: '3.26',

    // This option was added on v3.0.0 but will be removed in the next major release.
    // If you already have an script tag that loads Google Maps API and you want to use it set you callback
    // here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
    // to the `window` object, is the only requirement.
    customCallback: 'MyCustomCallback',
  },

  // [OPTIONAL] If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  autoBindAllEvents: false,

  // [OPTIONAL] If you want to manually install components, e.g.
  // import {GmapMarker} from 'gmap-vue/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,

  // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
  dynamicLoad: false,
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
